import RichTextEditor from './RichTextEditor'
import SystemRequirementsSection from './SystemRequirementsSection'

const ExtraInfoTab = ({
  updateInfo,
  setUpdateInfo,
  installationGuide,
  setInstallationGuide,
  minimumSystemRequirement,
  setMinimumSystemRequirement,
  recommendedSystemRequirement,
  setRecommendedSystemRequirement,
  showSystemRequirements,
}) => {
  return (
    <div className="postContentTabs__panel">
      <p>اطلاعات بروزرسانی</p>
      <div className="textEditor">
        <RichTextEditor value={updateInfo} onChange={setUpdateInfo} />
      </div>

      <p>راهنمای نصب</p>
      <div className="textEditor">
        <RichTextEditor value={installationGuide} onChange={setInstallationGuide} />
      </div>

      {showSystemRequirements && (
        <SystemRequirementsSection
          minimumSystemRequirement={minimumSystemRequirement}
          setMinimumSystemRequirement={setMinimumSystemRequirement}
          recommendedSystemRequirement={recommendedSystemRequirement}
          setRecommendedSystemRequirement={setRecommendedSystemRequirement}
        />
      )}
    </div>
  )
}

export default ExtraInfoTab
